module.exports = __webpack_public_path__ + "media/images/icons/icons_large/32_palm-b30becf24830f1b5b372f46ef4494f80.png";